import { t, Trans } from '@lingui/macro';
import { NoddiBasicCard } from 'noddi-ui-web';
import { InstructionRow } from '../InstructionsRow';

export const TireOfferNextInstructions = () => (
  <NoddiBasicCard className='flex flex-col gap-3'>
    <p className='mb-2 text-5'>
      <Trans>What happens next?</Trans>
    </p>
    <InstructionRow
      icon='Check'
      title={t`Order confirmation`}
      description={t`You'll receive an SMS confirmation with your order details within the next few minutes.`}
    />
    <InstructionRow
      icon='ClockCircle'
      title={t`Order processing`}
      description={t`Our team will process your order immediately and prepare your tires for shipment and installation. You will receive an SMS with estimated delivery time.`}
    />
    <InstructionRow
      icon='Calendar'
      title={t`Appointment Scheduling`}
      description={t`When your tires are ready, we will contact you to schedule the installation.`}
    />
  </NoddiBasicCard>
);
